// Zugriff auf die eigene API.
//
// Fehler kommen als Problem-Details (RFC 9457) zurueck, nicht als nackter
// Status. Deshalb wirft hier eine eigene Fehlerklasse, die den Text der API
// mitbringt: Was schiefgelaufen ist, weiss der Server besser als der Client.

export interface Problem {
  type: string;
  title: string;
  status: number;
  detail?: string;
}

export class ApiFehler extends Error {
  constructor(readonly problem: Problem) {
    super(problem.title);
    this.name = "ApiFehler";
  }
}

// Der CSRF-Token kommt aus /api/me und gilt fuer die ganze Sitzung. Er liegt
// im Modul und nicht im React-State, damit ihn auch Aufrufe ausserhalb der
// Komponenten haben.
let csrfToken: string | null = null;

export function merkeCsrfToken(token: string | null): void {
  csrfToken = token;
}

export async function api<T>(
  pfad: string,
  optionen: { method?: string; body?: unknown } = {},
): Promise<T> {
  const method = optionen.method ?? "GET";
  const kopf: Record<string, string> = {};
  if (optionen.body !== undefined) kopf["content-type"] = "application/json";
  if (method !== "GET" && csrfToken) kopf["X-CSRF-Token"] = csrfToken;

  const antwort = await fetch(`/api${pfad}`, {
    method,
    headers: kopf,
    body: optionen.body === undefined ? undefined : JSON.stringify(optionen.body),
  });

  if (antwort.status === 204) return undefined as T;

  const daten: unknown = await antwort.json().catch(() => null);

  if (!antwort.ok) {
    const problem = (daten ?? null) as Problem | null;
    throw new ApiFehler(
      problem?.title
        ? problem
        : { type: "unbekannt", title: `Die API antwortet mit ${antwort.status}`, status: antwort.status },
    );
  }

  return daten as T;
}

export function fehlertext(fehler: unknown): string {
  if (fehler instanceof ApiFehler) {
    return fehler.problem.detail ? `${fehler.problem.title}. ${fehler.problem.detail}` : fehler.problem.title;
  }
  if (fehler instanceof Error) return fehler.message;
  return "Unbekannter Fehler";
}
